import React from 'react';
import { CourseRegistrationPage } from './CourseRegistrationPage';

export function PartnerRegistrationPage() {
  return <CourseRegistrationPage isPartnerRegistration={true} />;
}
